var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.607 1H2.39311L11.4922 10.4375C12.0428 11.0086 12.9574 11.0086 13.5079 10.4375L22.607 1ZM1.16282 1.45286C1.05987 1.61007 1 1.79804 1 2V15.9601C1 16.0133 1.00416 16.0656 1.01218 16.1166L8.33069 8.88733L1.16282 1.45286ZM1.87382 16.9522C1.91515 16.9574 1.95726 16.9601 2 16.9601H23C23.1995 16.9601 23.3853 16.9017 23.5413 16.801L16.1136 9.46389L14.3718 11.2704C13.3493 12.331 11.6508 12.331 10.6283 11.2704L9.16365 9.75127L1.87382 16.9522ZM24 15.5674V2C24 1.79808 23.9402 1.61014 23.8372 1.45294L16.9465 8.59995L24 15.5674ZM0 2C0 0.895429 0.895431 0 2 0H23C24.1046 0 25 0.895431 25 2V15.9601C25 17.0646 24.1046 17.9601 23 17.9601H2C0.89543 17.9601 0 17.0646 0 15.9601V2Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.1b6a8147.svg";
export { ForwardRef as ReactComponent };